import src from "IMAGE";
export default { src, width: 880, height: 920, blurWidth: 0, blurHeight: 0};
